// @ts-nocheck
import { bToA } from '@kitconcept/volto-solr/components/theme/SolrSearch/base64Helpers';

export const encodeExtraConditions = (extraConditions) =>
  extraConditions.length === 0 ? '' : bToA(JSON.stringify(extraConditions));
